<template>
  <div class="c-confirmation-header text-size-5 line-height-8">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.c-confirmation-header {
  letter-spacing: 0.25px;
}
</style>
